module.exports = __webpack_public_path__ + "img/miroir.dd63393.svg";